import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import {ThroughProvider} from 'react-through';
import './App.scss';
// import './assets/css/mdi.scss';
import './assets/quill/quill.bubble.scss';
import './assets/quill/quill.core.scss';
import './assets/quill/quill.snow.scss';
import './assets/css/custom-portal.scss';
import './assets/css/amanda.scss';
import './assets/css/dashboard.scss';
import './assets/css/fullcalendar.scss';
import './assets/css/primefaces.scss';
import './assets/css/sidebar.scss';
import './assets/css/header.scss';
import './assets/css/reminder.scss';
import './i18n';
import '../node_modules/@mdi/font/css/materialdesignicons.css';

import * as serviceWorker from './serviceWorker';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThroughProvider>
        <App />
    </ThroughProvider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
